var render = function () {
  var _vm$selectedProductDe, _vm$selectedProductDe2, _vm$selectedProductDe3, _vm$selectedProductDe4, _vm$selectedProductDe5, _vm$selectedProductDe6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.products.length > 0 ? _c('b-row', _vm._l(_vm.products, function (item, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "cols": "6",
        "sm": "6",
        "md": "6",
        "lg": "4"
      }
    }, [_c('div', {
      staticClass: "card",
      class: {
        selected: _vm.selectedProduct === index
      },
      attrs: {
        "id": item === null || item === void 0 ? void 0 : item.id
      },
      on: {
        "click": function ($event) {
          return _vm.selectShopItem(index);
        }
      }
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('h3', {
      staticClass: "card-title"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.Name) + " ")]), _c('div', {
      staticClass: "card-image"
    }, [_c('img', {
      attrs: {
        "src": item === null || item === void 0 ? void 0 : item.thumbnail,
        "alt": item === null || item === void 0 ? void 0 : item.Name
      },
      on: {
        "error": function ($event) {
          return _vm.setFallbackImage($event);
        }
      }
    })]), _c('div', {
      staticClass: "card-price"
    }, [_c('img', {
      attrs: {
        "src": "/assets/images/shop/icons/coin.png",
        "alt": "Coin"
      }
    }), _c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.UnlockValue))])]), _c('div', {
      staticClass: "card-cta"
    }, [_c('b-button', {
      staticClass: "btn btn-warning",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.quickView(index);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/assets/images/shop/icons/view.png",
        "alt": "Icon"
      }
    }), _c('span', [_vm._v("Quick View")])])], 1)])])]);
  }), 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('br'), _vm._v("Sorry, no product available here at this moment.")])], 1), _vm.showModal ? _c('div', {
    staticClass: "product-detail"
  }, [_c('div', {
    staticClass: "product-content",
    class: {
      'animate-rtl': _vm.showModal === true
    }
  }, [_c('button', {
    staticClass: "btn-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("   ")]), _c('div', {
    staticClass: "topup"
  }, [_c('div', {
    staticClass: "gem"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/gem.png",
      "alt": "Gem Icon"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.userGems))]), _c('b-button', {
    staticClass: "btn-add",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.activateChildTab(1);
      }
    }
  }, [_vm._v("+")])], 1), _c('div', {
    staticClass: "coin"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/coin.png",
      "alt": "Coin Icon"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.userCoins))]), _c('b-button', {
    staticClass: "btn-add",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.activateChildTab(0);
      }
    }
  }, [_vm._v("+")])], 1)]), _c('div', {
    staticClass: "product-body"
  }, [_c('h3', {
    staticClass: "product-title"
  }, [_c('button', {
    staticClass: "btn-back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("   ")]), _vm._v(" " + _vm._s((_vm$selectedProductDe = _vm.selectedProductDetail) === null || _vm$selectedProductDe === void 0 ? void 0 : _vm$selectedProductDe.Name) + " ")]), _c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": (_vm$selectedProductDe2 = _vm.selectedProductDetail) === null || _vm$selectedProductDe2 === void 0 ? void 0 : _vm$selectedProductDe2.thumbnail,
      "alt": (_vm$selectedProductDe3 = _vm.selectedProductDetail) === null || _vm$selectedProductDe3 === void 0 ? void 0 : _vm$selectedProductDe3.Name
    }
  })]), [0, 1].includes(_vm.selectedProductDetail.Type) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('span', {
    staticClass: "progress-title"
  }, [_vm._v("AERO")]), _c('b-progress', {
    staticClass: "w-100",
    attrs: {
      "value": (_vm$selectedProductDe4 = _vm.selectedProductDetail) === null || _vm$selectedProductDe4 === void 0 ? void 0 : _vm$selectedProductDe4.Aerodynamics,
      "max": 100,
      "variant": "info"
    }
  })], 1) : _vm._e(), [0, 1].includes(_vm.selectedProductDetail.Type) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('span', {
    staticClass: "progress-title"
  }, [_vm._v("WEIGHT")]), _c('b-progress', {
    staticClass: "w-100",
    attrs: {
      "value": (_vm$selectedProductDe5 = _vm.selectedProductDetail) === null || _vm$selectedProductDe5 === void 0 ? void 0 : _vm$selectedProductDe5.Weight,
      "max": 100,
      "variant": "dark"
    }
  })], 1) : _vm._e(), _c('p', {
    staticClass: "product-description"
  }, [_vm._v(" " + _vm._s((_vm$selectedProductDe6 = _vm.selectedProductDetail) === null || _vm$selectedProductDe6 === void 0 ? void 0 : _vm$selectedProductDe6.Description) + " ")]), _c('p', {
    staticClass: "product-price"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/coin.png",
      "alt": "Coin Icon"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.selectedProductDetail.UnlockValue))])]), _c('div', [_vm.showPurchaseError ? _c('p', {
    staticClass: "alert alert-danger text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.showPurchaseError))])]) : _vm.showPurchaseBtn && !_vm.showPurchaseError ? _c('b-button', {
    staticClass: "btn btn-buy",
    attrs: {
      "variant": "dark"
    },
    on: {
      "click": _vm.purchaseItem
    }
  }, [_vm._v(" Buy Now ")]) : _vm._e(), _vm.showPurchaseMessage ? _c('p', {
    staticClass: "text-bg-info mt-3 text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.showPurchaseMessage))])]) : _vm._e()], 1)])])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }